/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import styles from '../../assets/css/layoutMain/companyProfile/companyProfiles.module.css';
import images from '../../assets/images';
import useModal from '../../hooks/useModal.js';
import { useGetUserProfile } from '../../hooks/api/useUserProfile.js';
import BtnOpenEmailPhone from '../../components/button/BtnOpenEmailPhone.js';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../../components/button/Button.js';
import AlertCustom from '../../components/alert/AlertCustom';
import useEditIntro from '../profile/useEditIntro';
import useEditAbout from '../profile/useEditAbout';
import useEditPictures from '../profile/useEditPictures';
import './profile.css';

const ProfileMain = () => {
    const { data, isLoading } = useGetUserProfile();
    const [tap, setTap] = useState(1);
    const [showMore, setShowMore] = useState(false);

    const { email } = useSelector(state => state.auth.user);

    const dispatch = useDispatch();

    useEffect(() => {
        console.log('profile main');
        dispatch({
            type: 'SET_LOAD_PROFILE'
        });
        console.log('profile main 222');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [openEditPicture, ModalEditPicture] = useEditPictures();
    const [openEditCover, ModalEditCover] = useEditPictures({ isCover: true });
    const [openModalUserInfo, modalEditIntroForm] = useEditIntro();
    const [openModalFomrAbout, modalEditAboutForm] = useEditAbout();

    const [modalAlertPhone, closeModalAlertPhone, openModalAlertPhone] =
        useModal();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    const CollapsibleUserDetails = () => {
        const userDetails = [
            { title: 'About', value: data.about },
            { title: 'LinkedIn', value: data.linkedIn, url: data.linkedIn },
            { title: 'Awards', value: data.awards },
            { title: 'Segment', value: data.segment },
            { title: 'Company', value: data.company },
            { title: 'Department', value: data.companyDepartment },
            { title: 'Markets', value: data.markets },
            { title: 'Solutions', value: data.solutions },
            { title: 'Certifications', value: data.certificationsDesignation },
            {
                title: 'Undergraduate School',
                value: `${data.undergraduateSchool ?? ''} ${
                    data.undergraduateSchoolLastYear ?? ''
                }`
            },
            {
                title: 'Graduate School',
                value: `${data.graduateSchool ?? ''} ${
                    data.graduateSchoolLastYear ?? ''
                }`
            },
            { title: 'Volunteer', value: data.volunteerInterests }
        ];

        const itemsToRender = userDetails.slice(
            0,
            showMore ? userDetails.length : 1
        );

        return (
            <>
                {itemsToRender.map(({ title, value, url }) => {
                    if (url) {
                        return (
                            <>
                                <h4>{title}</h4>
                                <p>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {value}
                                    </a>
                                </p>
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h4>{title}</h4>
                                <p>{value}</p>
                            </>
                        );
                    }
                })}
            </>
        );
    };

    const handleResumeButtonOnClick = () => {
        if (data.resume) {
            window.open(data.resume, '_blank').focus();
        }
    };

    return (
        <>
            <div className={styles.companyProfile}>
                <section className={styles.companyProfileInfo}>
                    <div className={styles.companyProfileBackground}>
                        <div className={styles.backgroundBtnEdit}>
                            <Button
                                onClick={openEditCover}
                                icon={images.pencilMain}
                                alignImg="left"
                                classs="btnRoundedIconMain"
                                text="Edit"
                            />
                        </div>
                        <img
                            className={styles.companyProfileBackgroundImg}
                            src={
                                data.coverPicture ||
                                'https://www.criptotendencias.com/wp-content/uploads/2019/11/En-Nueva-York-se-venden-propiedades-inmobiliarias-en-Bitcoin-la-%C3%BAltima-por-15-millones-de-d%C3%B3lares.jpg'
                            }
                            alt="backgroundimg"
                        />
                        <div className={styles.wrapperUserPhoto}>
                            <img
                                className={styles.companyProfileUserPhoto}
                                src={data.profilePicture || images.profile3}
                                alt="user"
                            />
                            <Button
                                onClick={openEditPicture}
                                icon={images.pencilMain}
                                alignImg="left"
                                classs="btnRoundedIconMain"
                            />
                        </div>
                    </div>

                    <div className={styles.companyProfileUser}>
                        <div className={styles.companyProfileBtn}>
                            <Button
                                onClick={openModalUserInfo}
                                icon={images.pencilMain}
                                alignImg="left"
                                classs="btnRoundedIconMain"
                                text="Edit"
                            />
                        </div>
                        <div className={styles.wrapperName}>
                            <h3 className={styles.companyProfileUserName}>
                                {data.name} {data.lastname}
                            </h3>

                            <div className={styles.statusUserName}></div>
                            <span className={styles.statusText}>
                                {data.segment}
                            </span>
                        </div>
                        <div className={styles.textOccupation}>
                            <h5>
                                {data.title} at {data.company}
                            </h5>

                            <h4>
                                {data.city}, {data.state}, {data.country}
                            </h4>
                        </div>
                        <div className={styles.companyProfileUserFollowers}>
                            <a href="#!">
                                <strong>108</strong>
                                Followers
                            </a>

                            <a href="#!">
                                <strong>89</strong>
                                Following
                            </a>
                        </div>

                        <div className={styles.wrapperOpenVendorsHorizontal}>
                            {data.boardDirectors && (
                                <Button
                                    icon={images.boardOfDirectors}
                                    alignImg="left"
                                    classs="btnOutlineBlack"
                                    text="Board of Directors"
                                />
                            )}
                            {data.vendorOffers && (
                                <Button
                                    icon={images.checkBlack}
                                    alignImg="left"
                                    classs="btnOutlineBlack"
                                    text="Open to Vendor Offers"
                                />
                            )}
                        </div>

                        <div className={styles.companyProfileUserContact}>
                            <Button
                                fontSize="0.75rem"
                                icon={images.website}
                                alignImg="left"
                                classs="btnMain"
                                text="Resume"
                                onClick={handleResumeButtonOnClick}
                            />

                            {!data.privateEmail && (
                                <BtnOpenEmailPhone
                                    dataType={email}
                                    text="Email"
                                />
                            )}
                            {!data.privatePhone && (
                                <BtnOpenEmailPhone
                                    dataType={data.phone}
                                    text="Phone"
                                    openModalAlertPhone={openModalAlertPhone}
                                />
                            )}
                        </div>
                    </div>
                </section>

                <section className={styles.cardMain}>
                    <div className={styles.cardDescriptionsContent}>
                        <div className={styles.wrapperAboutBtnEdit}>
                            <Button
                                onClick={openModalFomrAbout}
                                icon={images.pencilMain}
                                alignImg="left"
                                classs="btnRoundedIconMain"
                                text="Edit"
                            />
                        </div>
                        <CollapsibleUserDetails />
                    </div>

                    <div className={styles.cardDescriptionsFooter}>
                        <h4 className={styles.cardDescriptionsFooterText}>
                            <a onClick={() => setShowMore(!showMore)} href="#!">
                                {showMore ? 'See Less' : 'See More'}
                            </a>
                        </h4>
                    </div>
                </section>

                <>
                    <section className={styles.cardMain}>
                        <nav className={styles.tabs}>
                            <a
                                onClick={() => setTap(1)}
                                className={tap === 1 ? styles.active : ''}
                                href="#!">
                                Posts
                            </a>

                            <a
                                onClick={() => setTap(3)}
                                className={tap === 3 ? styles.active : ''}
                                href="#!">
                                Mentions
                            </a>
                        </nav>
                    </section>

                    <section className={styles.cardMainContent}>
                        {tap === 1 && (
                            <div style={{ height: 350 }}>
                                <h1>Posts</h1>
                            </div>
                        )}

                        {tap === 3 && (
                            <div style={{ height: 350 }}>
                                <h1>Mentions</h1>
                            </div>
                        )}
                    </section>
                </>
                {modalEditIntroForm}
                {modalEditAboutForm}
                {ModalEditPicture}
                {ModalEditCover}
                <AlertCustom
                    showModal={modalAlertPhone}
                    title="Phone"
                    subtitle={data.phone}
                    typeAlert="info">
                    <>
                        <Button
                            onClick={() => {
                                closeModalAlertPhone();
                            }}
                            classs="btnMain"
                            text="Ok"
                        />
                    </>
                </AlertCustom>
            </div>
        </>
    );
};

export default ProfileMain;
